import React from 'react'
import { InfoCircle } from 'react-bootstrap-icons'

/**
 * An inline explanation attached to the thing it is about — a rule the record
 * is subject to, a consequence of the choice just made.
 *
 * Not for validation: a failed submit belongs in the sticky footer via
 * `ModalActions error`, where it stays visible however far the body is
 * scrolled. This is for things that are true before you press anything.
 */
const ModalNote = ({ tone = 'info', icon, title, children, className = '' }) => (
  <div className={`app-modal__note app-modal__note--${tone} ${className}`.trim()}>
    <span className='app-modal__note-icon'>{icon || <InfoCircle />}</span>
    <span>
      {title && <b className='d-block mb-1'>{title}</b>}
      {children}
    </span>
  </div>
)

export default ModalNote
